import { request } from "#/utils/request";

export enum FEED {
  MENOR_IDADE = "MENOR_IDADE",
  FAIXA_RISCO = "FAIXA_RISCO",
  SALDO_DEVEDOR = "SALDO_DEVEDOR",
  CAPITAL_INTEGRALIZADO = "CAPITAL_INTEGRALIZADO",
  RENDA = "RENDA",
  CADASTRO_ERRO = "CADASTRO_ERRO",
}

export interface IgetFeedBackAssociados {
  conta: string;
  cooperativa: string;
  codigoComissionado: string;
  documento: string;
  accountFeedback?: FEED;
}

interface FeedbackData {
  data: Data;
  errors: Errors;
}

interface Data {
  feedback: string;
}

interface Errors {
  message: string;
  code: number;
}

export const getFeedBackAssociados = async ({
  conta,
  cooperativa,
  codigoComissionado,
  documento,
  accountFeedback,
}: IgetFeedBackAssociados) =>
  (
    await request.get<FeedbackData>(
      `/associados/feedback?conta=${conta}&cooperativa=${cooperativa}&codigoComissionado=${codigoComissionado}&documento=${documento}&accountFeedback=${accountFeedback}`,
      {}
    )
  ).data;
